import { useState, type ReactNode } from 'react';
import { ToastContext } from './toast';
import './toast.scss';
import { errorIcon, infoIcon, warningIcon } from '../../utils/config';

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [message, setMessage] = useState<string | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [type, setType] = useState<'info' | 'warning' | 'error'>('info');

  const showToast = (msg: string, toastType: 'info' | 'warning' | 'error' = 'info') => {
    setMessage(msg);
    setType(toastType);

    setTimeout(() => setIsVisible(true), 10);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => setMessage(null), 400);
    }, 4000);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {message && (
        <div className={`toast-container ${type} ${isVisible ? 'visible' : ''}`}>
          <span className="toast-icon">
            {type === 'info' && infoIcon}
            {type === 'warning' && warningIcon}
            {type === 'error' && errorIcon}
          </span>
          <span className="toast-message">{message}</span>
        </div>
      )}
    </ToastContext.Provider>
  );
};
